<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
      :blur="''"
    ></loading>
    <gd-modal
      name="payment-gateway-modal"
      width="900px"
      :title="
        selectedIntegrationTitle
          ? selectedIntegrationTitle
          : $t('frontend_groovesell_paymeny_gateway_list')
      "
    >
      <div class="overflow-y-auto custom-scrollbars scroll-modal">
        <div class="px-6 py-6">
          <div class="flex flex-wrap" v-if="!showIntegrationForm">
            <div
              v-for="(integration, index) in availableIntegrations"
              :key="index"
              class="p-2"
              :class="
                integration.name === 'groove_pay' ||
                integration.name === 'groovepay_automated'
                  ? 'w-full'
                  : 'w-1/4'
              "
            >
                <div
                  v-if="
                    integration.name === 'groove_pay' ||
                    integration.name === 'groovepay_automated'
                  "
                >
                  <div
                    class="
                      flex
                      border border-grey-300
                      rounded
                      p-4
                      text-grey-darkest
                      cursor-pointer
                      relative
                    "
                    @click="
                      handleIntegrationClick(
                        integration.fields,
                        integration.name,
                        integration.display_name
                      )
                    "
                  >
                    <div class="w-32">
                      <img
                        src="../assets/images/logo/groovepay-integration.png"
                        alt=""
                      />

                      <div class="flex w-full justify-center mt-4">
                        <gd-button
                          class="h-10 px-6"
                          size="auto"
                          primary
                          @click="openGroovepay"
                          >Signup</gd-button
                        >
                      </div>
                    </div>
                    <div class="flex flex-col flex-1 ml-4">
                      <p class="text-lg font-bold mb-2">
                        Groovesell Is Best With Groovepay
                      </p>
                      <p class="text-sm mb-2">
                        <span class="font-bold">As Low As 2.85%</span
                        ><span class="text-xs"
                          >+ $0.25 per transaction for USA</span
                        >
                      </p>
                      <p class="text-sm font-bold mb-2">
                        The best and most affordable way to accept credit cards
                      </p>
                      <p class="text-sm mb-2">
                        Groovepay has No Application fees, No Credit Check
                        Required, No Monthly PCI Fees, No Monthly Statement
                        Fees, No Annual Fees, No Minimum Monthly Processing
                        Fees, No Cancellation Fees, Instant Same-Day Approval
                        And Flat Rate Pricing.
                      </p>
                    </div>
                    <div class="absolute top-0 right-0 -mt-6 -mr-6">
                      <img
                        src="../assets/images/icons/recommended-icon.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="h-full relative" v-else>
                  <div
                    class="
                      flex flex-col
                      h-full
                      items-center
                      border border-grey-300
                      rounded
                      overflow-hidden
                      p-4
                      text-grey-darkest
                    "
                    :class="
                      isGroovester(integration.groove_only)
                        ? 'cursor-pointer'
                        : 'pointer-events-none'
                    "
                    @click="
                      handleIntegrationClick(
                        integration.fields,
                        integration.name,
                        integration.display_name
                      )
                    "
                  >
                    <div>
                      <div v-if="integration.name === 'stripe'">
                        <img
                          src="../assets/images/logo/stripe-integration.png"
                          alt=""
                          class="h-16"
                        />
                      </div>
                      <div v-if="integration.name === 'authorize.net'">
                        <img
                          src="../assets/images/logo/authorize-net-integration.png"
                          alt=""
                          class="h-16"
                        />
                      </div>
                      <div v-if="integration.name === 'nmi'">
                        <img
                          src="../assets/images/logo/nmi-integration.png"
                          alt=""
                          class="h-16"
                        />
                      </div>
                      <div v-if="integration.name === 'paypal_commerce'">
                        <img
                          src="../assets/images/logo/paypal-integration.png"
                          alt=""
                          class="h-16"
                        />
                      </div>
                      <div v-if="integration.name === 'braintree'">
                        <img
                          src="../assets/images/logo/braintree.png"
                          alt=""
                          class="h-16"
                        />
                      </div>
                      <div v-if="integration.name === 'mollie'">
                        <img
                          src="../assets/images/logo/mollie-integration.png"
                          alt=""
                          class="h-16"
                        />
                      </div>
                      <div v-if="integration.name === 'stax'">
                        <img
                          src="../assets/images/logo/stax-integration.png"
                          alt=""
                          class="h-16"
                        />
                      </div>
                      <div v-if="integration.name === 'pagarme'">
                        <img
                          src="../assets/images/logo/groovepay-integration.png"
                          alt=""
                          class="h-16"
                        />
                        <!--
                        <div
                          class="
                            w-8
                            h-8
                            flex
                            justify-center
                            items-center
                            bg-pink
                            rounded-full
                            absolute
                            left-0
                            top-0
                            -ml-3
                            -mt-2
                          "
                        >
                          <i class="fas fa-lock text-sm text-white"></i>
                        </div>
                        -->
                      </div>
                    </div>
                    <div class="mt-4">
                      {{ integration.display_name }}
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div class="px-2" v-if="showIntegrationForm">
            <div
              v-if="
                selectedIntegrationType == 'braintree' ||
                selectedIntegrationType == 'authorize.net'
              "
              class="
                flex
                mb-4
                bg-grey-100
                text-sm
                font-semibold
                text-grey-700
                p-2
              "
            >
              <i class="fas fa-info-circle mr-2 mt-1"></i>
              <div class="flex-1">
                Note : For Braintree and Authorize.net payment gateway the
                currency of integration account should match with the funnel
                currency.
              </div>
            </div>
            <div
              v-if="
                selectedIntegrationType == 'nmi' ||
                selectedIntegrationType == 'paypal'
              "
              class="
                flex
                mb-4
                bg-grey-100
                text-sm
                font-semibold
                text-grey-700
                p-2
              "
            >
              <i class="fas fa-info-circle mr-2 mt-1"></i>
              <div class="flex-1">
                Note : For NMI and Paypal we only support USD make sure the
                funnel currency is in USD .
              </div>
            </div>
            <div class="flex flex-col mb-4">
              <label class="font-semibold text-sm text-grey-700 mb-2">{{
                $t('frontend_product_step3_name')
              }}</label>
              <text-input
                v-model="selectedIntegrationName"
                :validator="$v.selectedIntegrationName"
                :attribute="$t('frontend_product_step3_name')"
                class="text-dark text-sm"
                :placeholder="$t('frontend_product_step3_name')"
              />
            </div>
            <div
              v-for="(field, index) in formfields"
              :key="index"
              class="flex flex-col mb-4"
            >
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ formfields[index].label }}
              </label>
              <text-input
                v-model="formfields[index].value"
                :validator="$v.formfields.$each[index].value"
                :attribute="formfields[index].label"
                class="text-dark text-sm"
                value="formfields[index].value"
                :placeholder="formfields[index].label"
              />
            </div>
            <div class="flex justify-end">
              <gd-button
                size="auto"
                class="
                  h-10
                  btn-width
                  px-4
                  btn-radius
                  text-base
                  font-semibold
                  border-grey-300
                "
                @click="backToGateway"
                >{{ $t('frontend_groovesell_back_to_list') }}</gd-button
              >
              <gd-button
                class="
                  h-10
                  btn-width
                  px-4
                  btn-radius
                  text-base
                  font-semibold
                  ml-4
                "
                size="auto"
                primary
                @click="registerIntegration"
                >{{ $t('frontend_product_step3_create') }}</gd-button
              >
            </div>
          </div>
        </div>
      </div>
    </gd-modal>
  </div>
</template>

<script>
import axios from 'axios';
import Auth from '@groovepages/gd-lib/auth';
import themeConfig from '../theme/themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  required,
  minLength,
  maxLength,
  alphaNum,
} from 'vuelidate/lib/validators';
import Integration from '../models/Integration';
import createLinkMixin from '../mixins/createLinkMixin';

import { userRegion } from '../../../../utils';

export default {
  name: 'PaymentGateway',
  mixins: [createLinkMixin],
  components: { Loading },
  props: {
    localGatewayList: {
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      fullPageLoader: true,
      loaderColor: themeConfig.appPrimaryColor,
      paymentIntegrations: [],
      userData: {},
      selectedIntegrationTitle: '',
      selectedIntegrationType: '',
      selectedIntegrationName: '',
      formfields: [],
      showIntegrationForm: false,
      localGatewayIntegrations: this.localGatewayList,
      genericUrl: `${window.config.apiUrl.split('/api')[0]}/api`,
    };
  },
  validations: {
    formfields: {
      $each: {
        value: {
          required,
        },
      },
    },
    selectedIntegrationName: {
      required,
      maxLength: maxLength(100),
    },
    form: {},
  },
  watch: {
    localGatewayIntegrations() {
      this.$emit('updateIntegration', this.localGatewayIntegrations);
    },
  },
  computed: {
    availableIntegrations() {
      if (userRegion == 'brazil') {
        return this.paymentIntegrations.filter(el => {
          return ['paypal_commerce','stripe'].includes(el.name)
        })
      }
      return this.paymentIntegrations.filter((el) => {
        return this.isGroovester(el.groove_only);
      });
    },

    formattedFormfields() {
      const formattedFields = {};

      for (let i = 0; i < this.formfields.length; i++) {
        formattedFields[this.formfields[i].key] = this.formfields[i].value;
      }

      return formattedFields;
    },
  },
  async created() {
    this.userData = Auth.authenticatedUser();
    this.getintegrations();
  },
  methods: {
    openGroovepay() {
      this.openLink('https://app.groovepay.com/?refId=groovesell', '_blank');
      // window.open('https://app.groovepay.com/?refId=groovesell', '_blank');
    },

    async getintegrations() {
      const genericCoreUrl = `${window.config.apiUrl.split('/api')[0]}/api/groovedigital`;
      const { data } = await axios.get(
        `${genericCoreUrl}/paymentintegrationdata`
      );

      this.paymentIntegrations = data;
    },
    isGroovester(groove_only) {
      if (!groove_only) {
        return true;
      }
      const { email } = this.userData;
      const address = email.split('@').pop();
      return address === 'groovedigital.com';
    },
    handleIntegrationClick(fields, integration, integration_display_name) {
      switch (integration) {
        case 'paypal_commerce':
          this.ConnectPaypalCommerce();
          break;
        default:
          this.getFields(fields, integration, integration_display_name);
      }
    },
    getFields(fields, name, display_name) {
      this.selectedIntegrationType = name;
      this.showLoader();
      this.hideLoader();
      this.formFieldsResponse = JSON.parse(fields);
      this.formfields = [];

      for (const prop in this.formFieldsResponse) {
        if (this.formFieldsResponse.hasOwnProperty(prop)) {
          const newFormField = {};
          newFormField.key = this.formFieldsResponse[prop].key;
          newFormField.label = this.formFieldsResponse[prop].label;
          newFormField.value = '';
          this.formfields.push(newFormField);
        }
      }

      this.selectedIntegrationTitle = this.$t(
        'frontend_groovesell_connect_your_account',
        { gateway: display_name }
      );
      this.showIntegrationForm = true;
      // this.$root.$emit('modal-open', 'add-integration-modal');
    },
    async registerIntegration() {
      this.$v.selectedIntegrationName.$touch();
      const isValid1 = !this.$v.selectedIntegrationName.$invalid;

      this.$v.formfields.$touch();
      const isValid2 = !this.$v.formfields.$invalid;
      if (isValid1 && isValid2) {
        this.showLoader();
        const newIntegration = new Integration({
          name: this.selectedIntegrationName,
          platform: this.selectedIntegrationType,
          details: this.formattedFormfields,
        });

        const savedIntegrationData = await newIntegration.save();
        const newlyAddedIntegrationData = await Integration.$find(
          savedIntegrationData.data.id
        );
        this.localGatewayIntegrations.push(newlyAddedIntegrationData);
        this.$root.$emit('modal-close', 'payment-gateway-modal');
        this.selectedIntegrationName = '';
        this.hideLoader();
        this.backToGateway();
      }
    },
    async ConnectPaypalCommerce() {
      this.showLoader();
      const funnel_id = this.$route.params.id;
      const { product_id } = this.$route.params;
      this.tokenData = await axios.post(`${this.genericUrl}/groovesell/paypal_commerce`, {
        funnel_id,
        product_id,
      });

      const paypalWindow = window.open(
        this.tokenData.data.links[1].href,
        '_blank'
      );

      /*
      const self = this;
      var timer = setInterval(async () => {
        if (paypalWindow.closed) {
          clearInterval(timer);
          self.showLoader();
          self.localGatewayIntegrations = await Integration.$get();
          self.hideLoader();
          console.log('window closed');
        }
      }, 1000);
      */
      this.hideLoader();
      this.$root.$emit('modal-close', 'payment-gateway-modal');
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
    backToGateway() {
      this.showIntegrationForm = false;
      this.selectedIntegrationTitle = this.$t(
        'frontend_groovesell_paymeny_gateway_list'
      );
    },
  },
};
</script>

<style type="text/css">
.pink_checkboxes .bg-grey-800 {
  background-color: rgb(234, 61, 94);
}

.noImageMarketplaceIcon {
  /* background-image: url('../assets/images/icons/Gift.png'); */
}
</style>
